<li [ngClass]="{ open: isOpenSection('intro') }">
  <span class="notebook-sidebar-title" (click)="toggleSection('intro')">
    <capra-icon icon="icon-chevron-right"></capra-icon> Intro to Notebooks
  </span>
  <div *ngIf="!isRegisterImportedDatasetEnabled" class="item-text">
    <p>
      A new Notebook automatically loads an index of your report queries. Your query results are accessible in R as
      <code>data.frame</code> objects.
    </p>
    <p>
      Your <code>data.frame</code> objects may be accessed by querying the datasets object (example:
      <code>datasets[["your query name"]]</code> or <code>datasets[[1]]</code>). You can also access them by token or
      index ID. Learn more about accessing your queries
      <a target="_blank" [href]="helpDocs.links['https://mode.com/help/articles/notebook/#accessing-query-results']"
        >here</a
      >.
    </p>
    <p>
      The R Notebook will process R code when input cells are run, and return output accordingly. In order to use any of
      the R packages supported, you must first import the package to the Notebook (example:
      <code>library(ggplot2)</code>).
    </p>
    <p>
      <a (click)="goToSupportedLibraries.emit()">Supported packages</a> are referenced in this side panel, along with
      helpful notebook <a (click)="goToKeyboardShortcuts.emit()">keyboard shortcuts</a> and links to other resources,
      including various <a target="_blank" href="https://mode.com/example-gallery/">recipes</a> for analysis that will
      help you get started or accelerate your analysis for some common use cases.
    </p>
    <p>
      <i
        >Note: the <code>datasets</code> object updates when you run your SQL queries. If you rename a query, remember
        to run it again so that your Notebook has the latest results.</i
      >
    </p>
  </div>

  <!-- Help section including imported dataset instructions -->
  <div *ngIf="isRegisterImportedDatasetEnabled" class="item-text">
    <p>
      Your query results and reusable Datasets excluding calculated fields are accessible in R as
      <code>data.frame</code> objects. You can access them in the variable datasets using the token, name, or index of
      the query or Dataset:
    </p>
    <ul>
      <li>
        example: <code>datasets[["6763b688fb54"]]</code> or <code>datasets[[“your query or Dataset name”]]</code> or
        <code>datasets[[1]]</code>
      </li>
    </ul>
    <p>
      <i
        >Note: the <code>datasets</code> object updates when you run your SQL queries. If you rename a query or Dataset,
        remember to run it again so that your Notebook has the latest results. Learn more about accessing your queries
        and Datasets
        <a [href]="helpDocs.links['https://mode.com/help/articles/notebook/#accessing-query-results']" target="_blank"
          >here</a
        >.</i
      >
    </p>
    <p>
      The R Notebook will process R code when input cells are run, and return output accordingly. In order to use any of
      the R packages supported, you must first import the package to the Notebook (example:
      <code>library(ggplot2)</code>).
    </p>
    <p>
      <a (click)="goToSupportedLibraries.emit()">Supported packages</a> are referenced in this side panel, along with
      helpful notebook <a (click)="goToKeyboardShortcuts.emit()">keyboard shortcuts</a> and links to other resources,
      including various <a target="_blank" href="https://mode.com/example-gallery/">recipes</a> for analysis that will
      help you get started or accelerate your analysis for some common use cases.
    </p>
  </div>
</li>
